<!-- eslint-disable -->
<script setup>
import { useRouter } from 'vue-router';
import { useAccountStore } from '@/stores/account';
import { computed, onBeforeMount } from 'vue';
import { useI18n } from 'vue-i18n';
import { useReferralStore } from '@/stores/referral';
import Loader from '@/components/Common/Loader.vue';

const { t } = useI18n();
const router = useRouter();
const accountStore = useAccountStore();
const referralStore = useReferralStore();

const goToRoute = (route_path) => {
	if (route_path) router.push({ path: route_path });
	else router.push({ name: 'landing' });
};

const showTitle = computed(() => {
	if (router.currentRoute.value.name == 'account-referrals-dashboard') return t('account.account_referrals.referal_dashboard');
	if (router.currentRoute.value.name == 'account-referrals-activity') return t('account.account_referrals.referral_activity');
	if (router.currentRoute.value.name == 'account-referrals-players') return t('account.account_referrals.referral_players');
});

const showSubtitle = computed(() => {
	if (router.currentRoute.value.name == 'account-referrals-dashboard') return t('account.account_referrals.manage_referrals');
	if (router.currentRoute.value.name == 'account-referrals-activity') return t('account.account_referrals.track_earnings');
	if (router.currentRoute.value.name == 'account-referrals-players') return t('account.account_referrals.track_player_performance');
});

onBeforeMount(() => {
	referralStore.fetchReferralCustomerInfo();
});

</script>

<template>
	<div class="dashboard-tab-content">
		<div class="tab-content-outer">
			<div class="dash-inner-tabs">
			</div>

			<div class="dash-content-main history-outer-main cardLayoutDashboard" id="withdraw">
				<div class="dash-content-outer">
					<div class="dash-main-content">
						<div class="title transaction-title">
							<h3>{{ showTitle }}</h3>
						</div>
						<div class="title transaction-subtitle">
							<span>{{ showSubtitle }}</span>
						</div>
						<div class="transaction-dash-main">
							<div class="dash-inner-topbar settled-inner-topbar">
								<div class="topbar-inner-left">
								</div>
								<div class="topbar-inner-right">
								</div>
							</div>

							<div class="close-btn" @click="goToRoute(accountStore.getPreviousRoute)">
								<svg xmlns="http://www.w3.org/2000/svg" width="21.414" height="21.414" viewBox="0 0 21.414 21.414">
									<g id="close" transform="translate(0.707 0.707)">
										<line id="Line_2" data-name="Line 2" x2="20" y2="20" fill="none" stroke="#ffff" stroke-linecap="round" stroke-width="1"></line>
										<line id="Line_3" data-name="Line 3" x1="20" y2="20" fill="none" stroke="#ffff" stroke-linecap="round" stroke-width="1"></line>
									</g>
								</svg>
							</div>
						</div>

						<template v-if="referralStore.initialization_loading">
							<Loader></Loader>
						</template>
						<template v-else>
							<router-view></router-view>
						</template>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.transaction-subtitle {
	font-size: 13px !important;
	color: var(--white) !important;
	font-weight: 300 !important;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.dashboard-main .dashboard-outer .dash-mobile-title {
		padding:unset;
		padding-bottom: 10px;
		/* padding-top: 20px; */
	}
}
@media screen and (min-width: 768px) and (max-width: 991px) {
	.dashboard-main .dashboard-outer .dash-mobile-title {
		padding:unset;
		padding-bottom: 20px;
		/* padding-top: 30px; */
	}
}
html[dir="rtl"] .dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .close-btn {
	right: unset;
	left: 50px;
}
html[dir="rtl"] .dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .dashboard-footer .dash-btns:last-child {
	text-align: left;
}

.close-btn {
	cursor: pointer;
}

.inner-tab-item {
	cursor: pointer;
}
@media screen and (min-width: 320px) and (max-width: 355px) {
	.dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .dash-inner-topbar .topbar-inner-left .tab .inner-tab-item {
		font-size: 12px!important;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	.dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .title h3 {
		font-size: 22px;
		font-weight: 500;
		color: var(--white);
		margin-top: 15px;
		display:none;
	}
}

.dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .dash-inner-topbar .topbar-inner-left .tab .inner-tab-item.active::after {
	position: absolute;
	content: "";
	height: 2px;
	width: 100%;
	/* background: linear-gradient(var(--primary) 0%, var(--primary) 100%); */
	bottom: 0px;
	left: 0;
}

.dashboard-main .dashboard-outer .dashboard-tab-content .dash-content-main .dash-content-outer .dash-inner-topbar .topbar-inner-left .tab .inner-tab-item {
	font-size: 13px;
	font-weight: 300;
	position: relative;
	padding-bottom: 6px;
}

/* @media screen and (max-width: 400px) { */
	/* .dashboard-main .dashboard-outer .dashboard-tab-content {
		padding: unset !important;
	} */
/* } */


.bonus-main{
	overflow: auto !important;
}

@media screen and (min-width: 400px) and (max-width: 991px) {
	.dashboard-main .dashboard-outer .dashboard-tab-content {
		padding-left: 20px !important;
		padding-right: 20px !important;
		padding-bottom: unset !important;
	}

}

@media screen and (max-width: 400px) {
	.dashboard-main .dashboard-outer .dashboard-tab-content {
		padding: unset !important;
	}

}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.dashboard-main .dashboard-outer .dashboard-tab-content {
		padding-bottom: unset !important;
	}
}

.cardLayoutDashboard {
	overflow: auto !important;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	.title .transaction-title {
		display:block;
	}
}

.dashboard-main .dashboard-outer .dashboard-tab-content .tab-content-outer {
	height: 100%;
}
</style>
